<template>
    <span>
        <template v-if="value && value.length || relationshipNotEmpty">
            <div v-if="canSeeAttribute">
                {{ value }}
            </div>
            <div v-else>
                <hidden-attribute-button
                    :model-id="model.id"
                    :model-type="modelType"
                    :attribute-name="attributeName"
                    :attribute-title="attributeTitle"
                >
                </hidden-attribute-button>
            </div>
        </template>
        <button
            v-else
            @click="showModal"
            type="button"
            class="bg-white border border-blue-300 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:ring-offset-2 font-medium hover:bg-blue-50 hover:border-blue-400 inline-flex items-center justify-between leading-extra-tight p-2.5 py-0.5 rounded-full shadow-sm space-x-2 text-white text-xs"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-5 h-5 -ml-1 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
            >
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" />
            </svg>
            <span class="italic font-medium text-gray-700">
                {{ buttonLabel }}
            </span>
        </button>
    </span>
</template>

<script>
export default {
    props: {
        model: {
            type: [Array, Object],
            required: true,
        },
        modelType: {
            type: String,
            required: true,
        },
        buttonLabel: {
            type: String,
            default: 'Request this info',
        },
        value: {
            type: String,
            required: false,
        },
        attributeName: {
            type: String,
            required: true,
        },
        attributeTitle: {
            type: String,
            required: true,
        },
        canSeeAttribute: {
            type: Boolean,
            required: false,
        },
        relationshipNotEmpty: {
            type: Boolean,
            required: false,
        }
    },
    data () {
        return {};
    },
    methods: {
        showModal: function () {
            OSPEvent.$emit('open-profile-data-request-modal', this.modelType, this.model.id, this.attributeName, this.attributeTitle, this.canSeeAttribute);
        },
    },
};
</script>
